module.exports = __webpack_public_path__ + "static/50-4d738c39c2a436fa2848d039521779e9.png";